import Constant from '@/common/constant/Constant';
import { Button, IconButton, Tooltip, Popover } from '@material-ui/core';
import { disabledAllField } from './handler/KnowledgeTicketHandler';
import Utils from '@/common/utils/utils';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { closePanelTabSelector, setPanelSelector } from '@/state/selector/panelSelector';
import { multiPanelAtom } from '@/state/atom/panelAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { userAtom } from '@/state/atom/userAtom';
import { projectIdListUserIsB2CAtom } from '@/state/atom/projectAtom';
import './ButtonSubmitAddTicket.css';
import { useState } from 'react';
import PropTypes from 'prop-types';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

const ButtonSubmitAddTicket = props => {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const {
        onClick,
        onClickDraft,
        onClickDelete,
        ticketType,
        isEdited,
        displayMode,
        setDisplayMode,
        setIsConfirmCancelEditTicket
    } = props;
    const detailTicket = props?.detailTicket;

    const userDetail = useRecoilValue(userAtom);
    const projectIdListUserIsB2C = useRecoilValue(projectIdListUserIsB2CAtom);
    let isDuplicate = props.isDuplicate;
    const isDisableButtonDraft = props?.isDisableButtonDraft;
    const isDisableButtonSent = props?.isDisableButtonSent;
    const isShowButtonDelete = props.isEnableButtonDelete && !isDuplicate;

    const addNewPanel = useSetRecoilState(setPanelSelector);
    const panelList = useRecoilValue(multiPanelAtom);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const corporationDetail = useRecoilValue(corporationAtom);

    // show more actions popover
    const [anchorShowMoreActionsPopover, setAnchorShowMoreActionsPopover] = useState(null);
    const isOpenShowMoreOptionsPopover = Boolean(anchorShowMoreActionsPopover);

    const onChangeViewMode = e => {
        if (displayMode === Constant.DISPLAY_MODE.EDIT && isEdited) {
            return setIsConfirmCancelEditTicket(true);
        }

        setDisplayMode(preMode => {
            if (preMode === Constant.DISPLAY_MODE.EDIT) {
                return Constant.DISPLAY_MODE.VIEW;
            } else {
                return Constant.DISPLAY_MODE.EDIT;
            }
        });
    };

    const onShowMoreActions = e => {
        setAnchorShowMoreActionsPopover(e?.currentTarget);
    };

    function onSubmitHandle() {
        onClick();
    }

    const onSubmitSaveDraftHandle = () => {
        onClickDraft();
        setAnchorShowMoreActionsPopover(false)
    };

    const onClickButtonDelete = () => {
        onClickDelete();
        setAnchorShowMoreActionsPopover(false)
    };

    const isEnableButtonDraftForDuplicate = () => {
        if (isDuplicate) return false;
        return (
            isDisableButtonDraft ||
            disabledAllField(props.panelList, props.tabId, props.handleStatus)
        );
    };

    const isEnableButtonSentForDuplicate = () => {
        if (isDuplicate && !isEdited) return false;
        return (
            isDisableButtonSent ||
            disabledAllField(props.panelList, props.tabId, props.handleStatus)
        );
    };

    const onOpenKnowledge = () => {
        const existedKnowledgeHelpdeskTicketListPanel = panelList.find(panel =>
            (Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_LIST,
            Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST).includes(panel.type)
        );

        if (!Utils.isEmptyObject(existedKnowledgeHelpdeskTicketListPanel)) {
            closePanelTab({
                event: null,
                panelType: existedKnowledgeHelpdeskTicketListPanel.type,
                panelId: existedKnowledgeHelpdeskTicketListPanel.id,
                tabId: 'knowledge_ticket_list_tab'
            });
        }

        let addNewPanelParams = {
            type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
            componentName: Constant.COMPONENT_NAME.LIST_TICKET_KNOWLEDGE,
            tabId: 'knowledge_ticket_list_tab',
            visibilitySettingType: Constant.VISIBILITY_SETTING_TYPE.CUSTOMER,
            isCustomer: true,
            customerId: userDetail.id,
            projectSelectedId: props.projectTarget,
            corporationSelectedId: props.corporationTarget,
            props: {
                ...props,
                componentName: Constant.COMPONENT_NAME.LIST_TICKET_KNOWLEDGE,
                panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
            }
        };
        addNewPanel(addNewPanelParams);
        setAnchorShowMoreActionsPopover(false)
    };

    const renderButtonSendTicket = () => {
        let labelButton = trI18n('USER04BTN001');
        let ticketTypeOfTicket = props?.createTicketType
            ? props?.createTicketType
            : props?.ticketType;
        switch (ticketTypeOfTicket) {
            case Constant.TICKET_TYPE.MASTER_KNOWLEDGE:
            case Constant.TICKET_TYPE.KNOWLEDGE:
                labelButton = props.isDraft ? tr('公開') : trI18n('COMBTN011');
                break;
            case Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT:
                labelButton = trI18n('USER03BTN011');
                break;
            default:
                labelButton = trI18n('USER04BTN001');
                break;
        }

        if (
            (props?.editTicket &&
                props?.createTicketType !== Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT) ||
            isDuplicate
        ) {
            labelButton = trI18n('COMBTN011');
        }

        return (
            <Button
                className="btn-send  btn-primary btn-hg32"
                variant="contained"
                color="primary"
                disabled={isEnableButtonSentForDuplicate()}
                onClick={e => onSubmitHandle()}
                data-cy="btn-submit-add-ticket"
            >
                {labelButton}
            </Button>
        );
    };

    const isDisplayIconViewHelpdeskKnowledge = () => {
        if (!ticketType || ticketType !== Constant.TICKET_TYPE.QA) {
            return false;
        }

        if (
            Utils.isEmptyString(props.projectTarget) ||
            Utils.getPrefixOfId(props.projectTarget) !== 'project'
        ) {
            return false;
        }

        if (props.corporationTarget) {
            if (props.corporationTarget === corporationDetail.id) {
                // Disable when user is not B2C of project
                if (userDetail && Utils.isB2CUser(userDetail)) {
                    if (
                        Utils.isEmptyArray(projectIdListUserIsB2C) ||
                        !projectIdListUserIsB2C.includes(props.projectTarget)
                    )
                        return false;
                }

                return corporationDetail.knowledgeService === Constant.ACTIVE_FLAG.ACTIVE;
            } else {
                let listHelpdesk = [...props.externalHelpDeskList];
                let projectTargetData = listHelpdesk.find(
                    project => project.id === props.projectTarget
                );

                if (!projectTargetData || Utils.isEmptyObject(projectTargetData)) {
                    return false;
                }

                const corporationData = projectTargetData?.corporationData;
                if (Utils.isEmptyObject(corporationData)) {
                    return false;
                }

                const contractType = corporationData.contractType;
                if (contractType === Constant.CORPORATION_CONTRACT_TYPE.PREMIUM) {
                    return (
                        projectTargetData?.corporationData?.knowledgeService ===
                        Constant.ACTIVE_FLAG.ACTIVE
                    );
                } else {
                    const inviterSetting = Utils.convertJSONDataToObject(
                        corporationData.inviterSetting
                    );
                    return inviterSetting?.usingKnowledgeService === Constant.ACTIVE_FLAG.ACTIVE;
                }
            }
        }

        return false;
    };

    const isShowPopoverShowMoreActions = () => {
        return isShowButtonDelete;
    };

    const renderDraftMode = () => {
        return (
            <div className="col2">
                {displayMode === Constant.DISPLAY_MODE.EDIT && (
                    <div className="itemAddticket btn-addTicket-container">
                        <div className="wrap-btn-submit">
                            <div></div>
                            <div className="wrap-btn-add">
                                {props?.displayMode === Constant.DISPLAY_MODE.EDIT && (
                                    <Button
                                        className="btn-send btn-outline-primary btn-hg32 back-to-draft"
                                        variant="contained"
                                        color="primary"
                                        onClick={e => onChangeViewMode(e)}
                                    >
                                        {trI18n('BUTTON-CANCEL-EDIT')}
                                    </Button>
                                )}

                                <Button
                                    className="btn-send btn-outline-primary btn-hg32 button-submit-add-ticket"
                                    variant="contained"
                                    color="primary"
                                    disabled={isEnableButtonDraftForDuplicate()}
                                    onClick={e => onSubmitSaveDraftHandle()}
                                >
                                    {trI18n('CM-BUTTON-SAVE-AS-DRAFT')}
                                </Button>

                                {renderButtonSendTicket()}
                            </div>
                        </div>
                    </div>
                )}
                <div
                    className="itemAddticket btn-addTicket-container"
                    style={{ paddingTop: 0, paddingBottom: 0 }}
                >
                    <div className="wrap-btn-submit draft">
                        <div className="wrap-btn-add">
                            {props?.displayMode === Constant.DISPLAY_MODE.VIEW && (
                                <div>
                                    <IconButton
                                        onClick={e => onChangeViewMode(e)}
                                        className="itemNav"
                                    >
                                        <img src="/assets/image/edit-icon-dark.svg" alt="" />
                                    </IconButton>
                                </div>
                            )}
                            <div>
                                <IconButton onClick={e => onShowMoreActions(e)} className="itemNav">
                                    <img src="/assets/image/icon-more-panel.svg" alt="" />
                                </IconButton>
                            </div>
                        </div>
                    </div>

                    {isShowPopoverShowMoreActions() && (
                        <Popover
                            className="action-list mt-2"
                            style={{ width: 'auto'}}
                            id={'show-more-options-popover'}
                            open={isOpenShowMoreOptionsPopover}
                            anchorEl={anchorShowMoreActionsPopover}
                            onClose={() => setAnchorShowMoreActionsPopover(null)}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right'
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right'
                            }}
                        >
                            <ul>
                                {isShowButtonDelete && (
                                    <li>
                                        <Button
                                            variant="text"
                                            onClick={() => onClickButtonDelete()}
                                            disabled={disabledAllField(
                                                props?.panelList,
                                                props?.tabId,
                                                props?.handleStatus
                                            )}
                                        >
                                            <span className="item">
                                                <img
                                                    className='action-icon'
                                                    src="/assets/image/icon-tabs-delete.svg"
                                                    alt="delete icon"
                                                />
                                            </span>
                                            <span>{trI18n('COMBTN013')}</span>
                                        </Button>
                                    </li>
                                )}

                                {isDisplayIconViewHelpdeskKnowledge() && (
                                    <li>
                                        <Button variant="text" onClick={onOpenKnowledge}>
                                            <span className="item">
                                                <img
                                                    className='action-icon'
                                                    src="/assets/image/icon-link.svg"
                                                    alt="knowledge icon"
                                                />
                                            </span>
                                            <span>{trI18n('HAMBURGER-KNOWLEDGE-LIST')}</span>
                                        </Button>
                                    </li>
                                )}
                            </ul>
                        </Popover>
                    )}
                </div>
            </div>
        );
    };

    const renderCreateMode = () => {
        return (
            <div className="col2">
                <div className="itemAddticket btn-addTicket-container">
                    <div className="wrap-btn-submit">
                        {isDisplayIconViewHelpdeskKnowledge() && (
                            <div className="itemButton">
                                <Tooltip title={trI18n('KNOWLITT001')} placement="top" arrow>
                                    <IconButton className="itemNav" onClick={onOpenKnowledge}>
                                        <img src="/assets/image/icon-link.svg" alt="" />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        )}

                        <div className="wrap-btn-add">
                            {!Utils.isEmptyString(detailTicket?.deletedAt) ? (
                                <>
                                    <Button
                                        className="btn-send btn-delete btn-hg32"
                                        variant="contained"
                                        color="primary"
                                        onClick={() => props.setIsShowDialogDeleteTicket(true)}
                                    >
                                        {tr('完全削除')}
                                    </Button>
                                    <Button
                                        className="btn-send btn-outline-primary btn-hg32"
                                        variant="contained"
                                        color="primary"
                                        onClick={() => props.setIsShowDialogRestoreTicket(true)}
                                    >
                                        {tr('復元')}
                                    </Button>
                                </>
                            ) : (
                                <>
                                    {isShowButtonDelete && (
                                        <Button
                                            className="btn-send btn-delete btn-hg32"
                                            variant="contained"
                                            onClick={() => onClickButtonDelete()}
                                            disabled={disabledAllField(
                                                props.panelList,
                                                props.tabId,
                                                props.handleStatus
                                            )}
                                        >
                                            {trI18n('COMBTN013')}
                                        </Button>
                                    )}
                                    <Button
                                        className="btn-send btn-outline-primary btn-hg32 button-submit-add-ticket"
                                        variant="contained"
                                        color="primary"
                                        disabled={isEnableButtonDraftForDuplicate()}
                                        onClick={e => onSubmitSaveDraftHandle()}
                                    >
                                        {trI18n('CM-BUTTON-SAVE-AS-DRAFT')}
                                    </Button>
                                    {renderButtonSendTicket()}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            {props?.isDraftMode && renderDraftMode()} {!props?.isDraftMode && renderCreateMode()}
        </>
    );
};

ButtonSubmitAddTicket.propTypes = {
    displayMode: PropTypes.any,
    onClick: PropTypes.func,
    onClickDraft: PropTypes.func,
    onClickDelete: PropTypes.func,
    ticketType: PropTypes.any,
    isEdited: PropTypes.bool,
    setDisplayMode: PropTypes.func,
    detailTicket: PropTypes.object,
    isDuplicate: PropTypes.bool,
    isDisableButtonDraft: PropTypes.bool,
    isDisableButtonSent: PropTypes.bool,
    isEnableButtonDelete: PropTypes.bool,
    panelList: PropTypes.any,
    tabId: PropTypes.any,
    handleStatus: PropTypes.any,
    projectTarget: PropTypes.any,
    corporationTarget: PropTypes.any,
    createTicketType: PropTypes.any,
    isDraft: PropTypes.bool,
    editTicket: PropTypes.bool,
    externalHelpDeskList: PropTypes.array,
    setIsShowDialogRestoreTicket: PropTypes.func,
    setIsShowDialogDeleteTicket: PropTypes.func,
    isDraftMode: PropTypes.bool,
    setIsConfirmCancelEditTicket: PropTypes.func
};

export default ButtonSubmitAddTicket;
